const calculate = {
  calculate: {
    title: "為他人計算",
    subtitle: "為朋友、家人或客戶生成紫微斗數星盤",
    savedProfiles: "已儲存的檔案",
    noProfiles: "暫無已儲存的檔案",
    newCalculation: "新建計算",
    enterDetails: "輸入個人詳細資訊以生成其紫微斗數星盤",
    generateChart: "生成星盤",
    aboutZiWei: "關於紫微斗數",
    whatIsZiWei: "什麼是紫微斗數？",
    requiredInfo: "所需資訊",
    interpretation: "解讀",
    whatIsDescription: "紫微斗數是中國古代占星術系統，根據一個人的出生日期和時間建立星盤。它分析天體的位置，提供關於性格、人際關係、事業和人生道路的洞見。",
    requiredInfoDescription: "要建立準確的紫微斗數星盤，您需要準確的出生日期、時間和地點。資訊越精確，星盤就越準確。",
    interpretationDescription: "星盤分析提供關於生活各個方面的洞見，包括事業、人際關係、健康和個人發展。解讀結合了傳統智慧和現代心理學理解。",
  },

  form: {
    name: "姓名",
    relationship: "關係",
    gender: "性別",
    birthDate: "出生日期",
    birthTime: "出生時間",
    birthPlace: "出生地點",
    saveProfile: "儲存檔案",
    selectGender: "選擇性別",
    male: "男",
    female: "女",
    namePlaceholder: "姓名",
    relationshipPlaceholder: "例如：朋友、客戶、父親",
    birthPlacePlaceholder: "城市，國家",
    yourNamePlaceholder: "您的姓名",
    theirNamePlaceholder: "他們的姓名",
    cancel: "取消",
    createSelfProfile: "建立我的檔案",
    createOtherProfile: "建立檔案",
    selectedDate: "選擇日期",
    selectTime: "選擇時間",
    dateFormatHint: "請按照日/月/年格式輸入日期（例如：31/12/1990）",
    invalidDateFormat: "日期格式無效。請使用日/月/年格式",
    dontRememberBirthTime: "我不記得出生時間",
    submitting: "建立中...",
    email: "電子郵件",
    emailPlaceholder: "your@email.com",
  },
};

export default calculate;
